/**
 * MenuBg — shared menu background for full-screen overlay modals.
 * Renders the dark navy gradient + left/right circuit SVG panels so
 * secondary screens (Choose Match Mode, Challenge overlays, etc.)
 * share the same visual identity as the main menu.
 */
import React from 'react';

const circuitBase = {
  position: 'absolute',
  width: '100%',
  height: '100%',
  opacity: 0.45,
  pointerEvents: 'none',
  userSelect: 'none',
  zIndex: 0,
};

/** Spread into the outer overlay div's style to get the menu background. */
export const MENU_OVERLAY_BG = {
  background: 'linear-gradient(145deg, #0a0f1a 0%, #151b2b 100%)',
  overflow: 'hidden',
};

/** Drop <MenuBg /> as the first child of any fixed overlay div. */
export default function MenuBg() {
  return (
    <>
      <img
        src={`${process.env.PUBLIC_URL}/circuit-primary-left.svg`}
        style={{ ...circuitBase, top: '-50px', left: 0 }}
        alt=""
        aria-hidden="true"
      />
      <img
        src={`${process.env.PUBLIC_URL}/circuit-primary.svg`}
        style={{ ...circuitBase, top: 0, right: 0 }}
        alt=""
        aria-hidden="true"
      />
    </>
  );
}
